"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogarithmNode = void 0;
const BaseNode_1 = require("../../BaseNode");
const Schema = __importStar(require("./schema.json"));
const NODE_TYPE = 'LOGARITHM';
class LogarithmNode extends BaseNode_1.BaseNode {
    constructor() {
        super(...arguments);
        this.logarithmBases = {
            'Base 2': 2,
            'Natural': Math.E,
            'Base 10': 10,
        };
        this._resolve = (params) => {
            var _a;
            const inputNum = params.inputNumber !== null ? Number(params.inputNumber) : NaN;
            if (isNaN(inputNum) || inputNum <= 0) {
                return { result: undefined };
            }
            const type = !this.config.type ? 'Base 10' : this.config.type;
            const base = !(params === null || params === void 0 ? void 0 : params.base) ? NaN : params.base !== null ? Number(params.base) : NaN;
            if (type === 'Custom Base' && isNaN(base)) {
                return { result: undefined };
            }
            const selectedBase = type === 'Custom Base' ? base : this.logarithmBases[type];
            if (selectedBase <= 0 || selectedBase === 1) {
                return { result: undefined };
            }
            const result = (_a = Math.log(inputNum) / Math.log(selectedBase)) !== null && _a !== void 0 ? _a : undefined;
            return { result };
        };
        this._interfaceDefinition = Schema;
    }
    get interfaceDefinition() {
        var _a;
        const InputParams = {
            type: 'object',
            properties: {
                inputNumber: {
                    description: 'Input Number',
                    title: 'inputNumber',
                    type: 'number',
                },
            },
            required: ['inputNumber'],
        };
        return Object.assign(Object.assign({}, Schema), { InputParams: ((_a = this.config) === null || _a === void 0 ? void 0 : _a.type) === 'Custom Base' ? this._interfaceDefinition.definitions.InputParams : InputParams, OutputParams: this._interfaceDefinition.definitions.OutputParams, ConfigParams: this._interfaceDefinition.definitions.ConfigParams });
    }
}
exports.LogarithmNode = LogarithmNode;
LogarithmNode._nodeDefinition = {
    NODE_TYPE,
    defaultTitle: 'Logarithm',
    isIdempotent: true,
    primaryCategory: 'Math',
};
//# sourceMappingURL=Logarithm.js.map